import React from 'react';
import AdminSidebarContent from '../../../components/layout/sidebar/AdminSidebarContent';
import '../../../styles/layout/sidebar.css';

const Sidebar = ({ onClose }) => {
  return <AdminSidebarContent onClose={onClose} showClose />;
};

export default Sidebar;
